

























import Vue from 'vue'
import { Component, Prop } from 'vue-property-decorator'

@Component
export default class AccountServiceHeader extends Vue {
  @Prop()
  title: string

  @Prop({ default: '/' })
  topUrl: string
}
